// @core/api/endpoints/calendar/schedule_entity.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CalendarLifecycleResponse,
  ScheduleEntityRequest,
} from '../../../types/calendar';

const BASE_PATH = '/calendar';

/**
 * Schedule entity
 * Sets or updates the schedule (start/end time, timezone, location) for any entity with CalendarAspect. Validates availability per CalendarEventTypeDefinition. Works for standalone events and domain entities (Shift, ServiceBooking, PropertyShowing, etc.).
 */
export async function ScheduleEntity(
  target_type: string,
  target_id: string,
  data: ScheduleEntityRequest,
  options?: RequestOptions
): Promise<CalendarLifecycleResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/calendar/:target_type/:target_id/schedule`;
  requestPath = requestPath.replace(':target_type', encodeURIComponent(target_type));
  requestPath = requestPath.replace(':target_id', encodeURIComponent(target_id));
  const requestOptions = options;
  return client.post<CalendarLifecycleResponse>(requestPath, data, requestOptions);
}
